import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

/**
 * Layout base reutilizable para todos los módulos.
 *
 * Props:
 *  - titulo      (string)    Título que aparece en el header. Requerido.
 *  - logo        (string)    Ruta/import de la imagen del logo. Requerido.
 *  - onVolver    (function)  Opcional. Si no se pasa, hace navigate(-1) por defecto.
 *  - children    (ReactNode) Contenido del módulo.
 */

function ModuleLayout({ titulo, logo, onVolver, children, toastRef }) {
  const navigate = useNavigate();

  const volverAtras = onVolver ?? (() => navigate(-1));

  return (
    <div className="mod-container">
      <header className="mod-header pb-2">
        <div className="flex gap-3 align-items-center">
          <Button
            type="button"
            icon="pi pi-arrow-left"
            className="btn-volver-login"
            onClick={volverAtras}
          />
          <h3 className="mod-titulo mt-1 mb-0">{titulo}</h3>
        </div>
        <img src={logo} alt="Logo Transkyrios" className="mod-logo"/>
      </header>

      {/* CONTENIDO DEL MÓDULO */}
      {children}

    </div>
  );
}

export default ModuleLayout;